import React, { useEffect, useState } from "react";

// * Third Party
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, User } from "firebase/auth";
import Button from "@mui/material/Button";

// * Custom Components
import Loader from "../UI/Loader";

// * Db
import { auth, getUserRoles, logoutUser } from "../../lib";

// * Helpers
import { paths } from "../../routers";
import { constants } from "../../lib";

// * CSS
import "./login.css";

interface Props {
  children: React.ReactNode;
}

const AuthGuard = ({ children }: Props) => {
  const navigate = useNavigate();

  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const handleSuccess = (user: User) => {
    getUserRoles(user.uid).then((roles) => {
      setLoading(false);
      if (roles === constants.ROLE.ADMIN) {
        setIsAdmin(true);
      }
    });
  };

  const handleLogout = () => {
    logoutUser()
      .then(() => {
        navigate(paths.LOGIN);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        // Do a custom logic
      });
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        handleSuccess(user);
      } else {
        navigate(paths.LOGIN);
      }
    });
  }, []);
  return loading ? (
    <Loader />
  ) : isAdmin ? (
    <>{children}</>
  ) : (
    <div id="no-permission-container">
      <h1>This account doesn't have administrator access</h1>
      <div className="contact-form-btnbox logout-btn cust-form-item">
        <div className="logout-button-container">
          <Button
            className="submit-btn"
            variant="contained"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AuthGuard;
